<template>
  <v-list-item :dense="isMobile" v-if="listType === 'normal'" @click="$emit('click',item)" link>
    <v-list-item-action>
      <v-btn fab  small :color="color"> <v-icon> {{ icon }}</v-icon></v-btn>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-subtitle v-if="!hideType">
        {{ type }}
      </v-list-item-subtitle>
      <v-list-item-title>
        <strong> {{ item.BranchAddress }} - {{ item.ProjectName }} </strong>
      </v-list-item-title>
      <p class="pb-1" style="color:grey; font-size:0.8em ">
        {{ item.Description }}
      </p>
      <v-list-item-subtitle v-if="showStatus" style="border-top:1px solid #eeeeee" class="pt-1">
        <strong>
          {{ item.getLastDate() | date }}
          {{ item.getLastDate() | time }}:
        </strong>
        {{ item.getEventStatus() }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showDateEnd">
      {{ item.DateEnd | fullDate }}
    </v-list-item-action>
    <v-list-item-action v-if="!hideInsertDate">
      {{ item.DateEventInsert | fullDate }}
    </v-list-item-action>
  </v-list-item>


  <v-list-item :dense="isMobile" v-else-if="listType==='dense'"  @click="$emit('click',item)">
    <v-list-item-action>
      <v-btn fab  small :color="color"> <v-icon> {{ icon }}</v-icon></v-btn>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>
        {{ item.BranchAddress }} - {{ item.ProjectName }}
      </v-list-item-title>
      <v-list-item-subtitle v-if="!hideType">
        {{ type }} - {{ item.Description }}

      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="showStatus" style="border-top:1px solid #eeeeee" class="pt-1">
        <strong>
          {{ item.getLastDate() | date }}
          {{ item.getLastDate() | time }}:
        </strong>
        {{ item.getEventStatus() }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showDateEnd">
      {{ item.DateEnd | fullDate }}
    </v-list-item-action>
    <v-list-item-action v-if="!hideInsertDate">
      {{ item.DateEventInsert | fullDate }}
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EventDetails from "../../../wl-core/api/classes/EventDetails";
import {mapGetters} from "vuex";

export default {
  name: "EventMobileItem",
  props: {
    listType:{type:String, default:'normal', required:false},
    item: EventDetails,
    showStatus: {type: Boolean, default: null, required: false},
    showLastUpdate: {type: Boolean, default: null, required: false},
    hideType: {type: Boolean, default: null, required: false},
    hideInsertDate: {type: Boolean, default: null, required: false},
    minHeight: {type: String, default: "70", required: false},
    showDateEnd: {type: Boolean, default: null, required: false}
  },
  data: () => ({
    color: null,
    icon: '',
    type: null
  }),
  updated() {

  },
  computed: {
   ...mapGetters([
     'isMobile'
   ])
  },
  created() {
    switch (this.item.EventType_ID) {
      case 1:
        this.color = 'maintenance';
        this.type = 'Συντήρηση';
        this.icon = 'mdi-wrench-outline';
        break;
      case 2:
        this.color = 'callout';
        this.type = 'Βλάβη';
        this.icon = 'mdi-alert-outline';
        break;
      case 3:
        this.color = 'task';
        this.type = 'Άλλη Εργασία'
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
